// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"a30cb85e","358":"0a796108","473":"c9fe23ce"}[chunkId] + ".chunk.css";
};